export default class tipoEquipoService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/tipo_equipo',
			"id": '/api/tipo_equipo/:id',
			"new": '/api/tipo_equipo',
            "update": '/api/tipo_equipo',
			'delete': '/api/tipo_equipo/:id'
			// "one": '/api/tipo_equipo/one'
		};
	}

	getAll(params){
		let url = this.baseUrl + this.routes.all;
		let config = {};
		config.params = {};
		if (params !== undefined) {
			if (typeof params == 'string') {
				config.params.string = params;
			}else{
				for (var element in params) {
					config.params[element] = params[element];
				}
				config.params.proyectos = params.proyectos
			}
		}
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	destruct(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}

    update(data){
        let url = this.baseUrl + this.routes.update;
        return this.http.put(url, data);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/tipoEquipoService.js